module.exports = __webpack_public_path__ + "media/assets/icons/laptop-0e661f1f5285c755dd1d86ab1ba73c2b.svg";